import React from 'react';
import { useHelpContext } from '../context/help-context';
import { X } from 'lucide-react';

const HelpDrawer = () => {
    const { isOpen, closeHelp, helpContent: HelpContent } = useHelpContext();

    return (
        <>
            {/* Backdrop */}
            {isOpen && (
                <div
                    className="fixed inset-0 bg-black/50 z-[99] transition-opacity duration-300"
                    onClick={closeHelp}
                />
            )}

            {/* Drawer */}
            <div
                className={`fixed right-0 top-0 h-full w-[400px] max-w-full bg-white shadow-2xl z-[100] transform transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : 'translate-x-full'
                    }`}
            >
                {/* Header */}
                <div className="flex items-center justify-between p-4 border-b">
                    <h2 className="text-xl font-semibold text-gray-800">Help & Info</h2>
                    <button
                        onClick={closeHelp}
                        className="p-1 hover:bg-gray-100 rounded-full transition-colors"
                    >
                        <X className="w-6 h-6 text-gray-600" />
                    </button>
                </div>

                {/* Content */}
                <div className="p-6 overflow-y-auto h-[calc(100vh-64px)]">
                    {HelpContent ? (
                        <HelpContent />
                    ) : (
                        <div className="text-gray-500 text-center mt-10">
                            <h3 className="text-lg font-medium mb-2">No help instructions available</h3>
                            <p>There is no specific help documentation for this page yet.</p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default HelpDrawer;
